import _isEqual from 'lodash/isEqual';

import { helper } from '@ember/component/helper';

function isEqFn([left, right]: any[] /*, hash*/) {
  return _isEqual(left, right);
}

const isEqFnHelper = helper(isEqFn);
export default isEqFnHelper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'is-eq': typeof isEqFnHelper;
  }
}
